import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useQuestionResponse from "../../../Responses/useQuestionResponse";
import getChartColor from "./getChartColor";
import { selectedOptionIndexes } from "./answerOptions";

export default function MultiSelectBarChart() {
    const { question, answers } = useQuestionResponse();
    const { t } = useTranslation();

    const rows = useMemo(() => {
        const options = question.questionOptions ?? [];
        const counts = options.map(() => 0);

        answers.forEach(({ answerValue }) => {
            selectedOptionIndexes(answerValue).forEach((index) => {
                if (counts[index] !== undefined) counts[index] += 1;
            });
        });

        return options.map((option, index) => ({
            option,
            count: counts[index],
            percentage: answers.length > 0 ? (counts[index] / answers.length) * 100 : 0,
            fill: getChartColor(index),
        }));
    }, [question, answers]);

    return (
        <div className="flex min-w-0 flex-1 flex-col gap-3 pt-2">
            {rows.map(({ option, count, percentage, fill }, index) => (
                <div key={index} className="flex min-w-0 flex-col gap-1">
                    <div className="flex min-w-0 items-baseline justify-between gap-3">
                        <span className="min-w-0 flex-1 wrap-break-word text-sm font-light">
                            {option}
                        </span>
                        <span className="shrink-0 text-sm font-medium">
                            {count.toLocaleString("nb-NO")} (
                            {percentage.toLocaleString("nb-NO", { maximumFractionDigits: 0 })}%)
                        </span>
                    </div>
                    <div className="bg-compendia-greige-60 h-2 w-full rounded-full">
                        <div
                            className="h-2 rounded-full"
                            style={{ width: `${percentage}%`, backgroundColor: fill }}
                        />
                    </div>
                </div>
            ))}
            <p className="text-compendia-muted text-xs">
                {t("responseOverview.percentageOfRespondents")}
            </p>
        </div>
    );
}
